declare namespace $ {

	export class $exso_sheets_blowings_class extends $exso_sheets {
		paths( ): readonly(any)[]
		order_by( ): readonly(any)[]
		state( ): ({ 
			'wet': string,
			'dry': string,
			'unknown': string,
		}) 
		columns( ): ({ 
			'date': ({ 
				'title': string,
			}) ,
			'block': ({ 
				'title': string,
			}) ,
			'mesh': ({ 
				'title': string,
				'unit': string,
			}) ,
			'blasted': ({ 
				'title': string,
				'unit': string,
			}) ,
			'burnt': ({ 
				'title': string,
				'unit': string,
			}) ,
			'state': ({ 
				'title': string,
			}) ,
			'place': ({ 
				'title': string,
			}) ,
		}) 
	}
	
}

//# sourceMappingURL=blowings.view.tree.d.ts.map